import type { ReactNode } from 'react';
import { cx } from './cx';

type Tone = 'info' | 'attention' | 'critical' | 'positive';

const tones: Record<Tone, string> = {
  info: 'bg-surface-2 text-text-1',
  attention: 'bg-attention-soft text-text-1',
  critical: 'bg-critical-soft text-text-1',
  positive: 'bg-positive-soft text-text-1',
};

export function Banner({ tone = 'info', children, className }: { tone?: Tone; children: ReactNode; className?: string }) {
  return (
    <div
      role={tone === 'critical' ? 'alert' : 'note'}
      className={cx('rounded-card px-4 py-3 text-sm leading-relaxed', tones[tone], className)}
    >
      {children}
    </div>
  );
}
